export enum ParamsEnum {
	UID = 'uid',
	SHOW_PRICE_INFO = 'showPriceInfo',
	SUGGESTION = 'suggestionId',
	RATING = 'rating',
	PRINT = 'print',
	CORRECT = 'correct',
	NOTE = 'note',
	/** Marks a customer-service SIP order link (`?sipOrder&uid=<uid>`). */
	SIP_ORDER = 'sipOrder',
}
